import { PhotoVariableInput, ProcessedPhotoInput, UnprocessedPhotoInput } from './PhotoVariableInput';

export const hasUserInput = (
    input: PhotoVariableInput
): input is ProcessedPhotoInput | UnprocessedPhotoInput => {
    return 'processed' in input;
};